import React from 'react';
import { useLang, LANGUAGES } from '../../core/i18n';
import { useAuth } from '../../core/firebase/useAuth';
import { signOut } from 'firebase/auth';
import { auth } from '../../core/firebase/firebase';
import Footer from '../../components/Footer';

export default function SettingsPage() {
  const { t, lang, setLang, dir } = useLang();
  const { user } = useAuth();

  const handleLogout = async () => {
    try { await signOut(auth); } catch {}
  };

  return (
    <div style={{ background: '#f7f8fa', minHeight: '100vh', direction: dir }}>

      {/* ── Content ── */}
      <div style={s.inner}>
        <h2 style={s.pageTitle}>{t.settingsTitle}</h2>

        {/* Language */}
        <Section title={t.language} sub={t.languageSub}>
          <div style={s.langGrid}>
            {LANGUAGES.map(l => (
              <button
                key={l.code}
                style={{ ...s.langBtn, ...(lang === l.code ? s.langBtnOn : {}) }}
                onClick={() => setLang(l.code)}
              >
                <span style={s.flag}>{l.flag}</span>
                <span style={{ ...s.langName, color: lang === l.code ? '#fff' : '#333' }}>{l.label}</span>
                {lang === l.code && <span style={s.check}>✓</span>}
              </button>
            ))}
          </div>
          <p style={s.detectedNote}>🌐 {t.detected}</p>
        </Section>

        {/* Account */}
        {user && (
          <Section title={t.account}>
            <div style={s.userRow}>
              <div style={s.avatar}>{(user.displayName || user.email || '?')[0].toUpperCase()}</div>
              <div>
                <p style={s.userName}>{user.displayName || '—'}</p>
                <p style={s.userEmail}>{user.email}</p>
              </div>
            </div>
            <button style={s.logoutBtn} onClick={handleLogout}>{t.logout}</button>
          </Section>
        )}

        {/* Creator easter egg */}
        <div style={s.creatorBox}>
          <span style={s.creatorEmoji}>👑</span>
          <p style={s.creatorText}>WISE now do you believe?</p>
          <p style={s.creatorSub}>I'm Nexsap's creator 😎</p>
        </div>

        {/* Version */}
        <div style={s.versionRow}>
          <span style={s.versionText}>Nexsap · {t.version} 1.0.0</span>
        </div>
      </div>

      {/* ── Footer (full width, outside the inner container) ── */}
      <Footer />

    </div>
  );
}

function Section({ title, sub, children }) {
  return (
    <div style={s.section}>
      <div style={s.sectionHeader}>
        <p style={s.sectionTitle}>{title}</p>
        {sub && <p style={s.sectionSub}>{sub}</p>}
      </div>
      <div style={s.sectionBody}>{children}</div>
    </div>
  );
}

const s = {
  inner:        { padding: '20px 16px 32px', maxWidth: 520, margin: '0 auto' },
  pageTitle:    { fontSize: 22, fontWeight: 700, color: '#1a1a1a', marginBottom: 24 },
  section:      { background: '#fff', borderRadius: 16, marginBottom: 16, overflow: 'hidden', border: '1.5px solid #eaeaea' },
  sectionHeader:{ padding: '16px 16px 0' },
  sectionTitle: { fontSize: 13, fontWeight: 700, color: '#888', textTransform: 'uppercase', letterSpacing: 0.5, margin: 0 },
  sectionSub:   { fontSize: 12, color: '#bbb', margin: '3px 0 0' },
  sectionBody:  { padding: 16 },
  langGrid:     { display: 'flex', flexWrap: 'wrap', gap: 10 },
  langBtn:      { flex: '1 1 calc(50% - 8px)', display: 'flex', alignItems: 'center', gap: 10, padding: '12px 14px', borderRadius: 12, border: '1.5px solid #eaeaea', background: '#f7f8fa', cursor: 'pointer', position: 'relative' },
  langBtnOn:    { background: '#1a1a2e', border: '1.5px solid #1a1a2e' },
  flag:         { fontSize: 22 },
  langName:     { fontSize: 14, fontWeight: 600 },
  check:        { position: 'absolute', right: 12, color: '#4ade80', fontWeight: 700, fontSize: 16 },
  detectedNote: { fontSize: 12, color: '#bbb', marginTop: 10, textAlign: 'center' },
  userRow:      { display: 'flex', alignItems: 'center', gap: 12, marginBottom: 14 },
  avatar:       { width: 48, height: 48, borderRadius: 24, background: '#1877F2', color: '#fff', fontSize: 20, fontWeight: 700, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 },
  userName:     { fontSize: 15, fontWeight: 700, color: '#1a1a1a', margin: 0 },
  userEmail:    { fontSize: 13, color: '#888', margin: '2px 0 0' },
  logoutBtn:    { width: '100%', padding: '12px', borderRadius: 12, border: 'none', background: '#fff0f0', color: '#e74c3c', fontSize: 14, fontWeight: 700, cursor: 'pointer' },
  creatorBox:   { background: 'linear-gradient(135deg, #1a1a2e, #1877F2)', borderRadius: 16, padding: '20px 16px', marginBottom: 16, textAlign: 'center' },
  creatorEmoji: { fontSize: 32 },
  creatorText:  { fontSize: 16, fontWeight: 800, color: '#fff', margin: '8px 0 4px' },
  creatorSub:   { fontSize: 13, color: '#a0c4ff', margin: 0 },
  versionRow:   { textAlign: 'center', paddingTop: 8, paddingBottom: 8 },
  versionText:  { fontSize: 12, color: '#ccc' },
};
